module.exports = __webpack_public_path__ + "static/img/internet.05ca39c8.svg";